// extracted by mini-css-extract-plugin
module.exports = {"fullScreen":"cbRgFFH0","upflowyContainer":"_1DOyFJbY"};